import * as yup from "yup";

const CreateDailyNoteValidationForm = yup.object().shape({
  items: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          description: yup.string().required("Description is required"),

          debit: yup
            .number()
            .nullable()
            .transform((value, originalValue) =>
              originalValue === "" ? null : value
            )
            .min(1, "Debit must be greater than 0"),

          credit: yup
            .number()
            .nullable()
            .transform((value, originalValue) =>
              originalValue === "" ? null : value
            )
            .min(1, "Credit must be greater than 0"),
        })
        .test(
          "debit-credit-required",
          "fill at least one field",
          function (value) {
            const { debit, credit } = value || {};

            if (debit == null && credit == null) {
              return this.createError({
                path: `${this.path}.debit`,
                message: "fill at least one field",
              });
            }

            return true;
          }
        )
    )
    .min(1, "At least 1 item is required"),

  notes: yup.string().nullable().optional(),
});

export { CreateDailyNoteValidationForm };

